import React from 'react';
import { Link, Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import '../hr/hr.css';
import '../hr/ta.css';
import '../hr/hre.css';
import './payroll.css';
import { HRProvider } from '../hr/HRContext';
import Icon from '../hr/Icon';
import ModuleCard from '../components/ModuleCard';
import { PAYROLL_BASE, PAYROLL_MODULE, findGroup, findSubmodule, firstSub, payrollSubUrl } from './catalog';
import * as Screens from './screens';
import { usePerms } from './shared';

// Payroll & Compensation routes, as Stephanet's ModulePage / SubmodulePage:
//   /payroll            one card per group; a card opens the group's first sub-module
//   /payroll/g/:group   (the sidebar's group links) → the group's first sub-module
//   /payroll/s/:sub     a sub-module, with every sub-module of its group as a tab box above it
//   /payroll/:sub       older links → /payroll/s/:sub

function HubPage() {
  const navigate = useNavigate();
  return (
    <div className="fade-in">
      <p style={{ fontSize: 14, color: 'var(--text-secondary)', margin: '0 0 22px' }}>Select a {PAYROLL_MODULE.title} module below.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 18 }}>
        {PAYROLL_MODULE.groups.map(g => (
          <ModuleCard key={g.key} item={{ id: `payroll-${g.key}`, label: g.title, description: g.description }} color={g.color}
                      icon={<Icon name={g.icon} size={24} />} onOpen={() => navigate(payrollSubUrl(firstSub(g).key))} />
        ))}
      </div>
    </div>
  );
}

function GroupPage() {
  const { groupKey } = useParams();
  const group = findGroup(groupKey);
  return <Navigate to={group ? payrollSubUrl(firstSub(group).key) : PAYROLL_BASE} replace />;
}

function SubmodulePage({ user }) {
  const { subKey } = useParams();
  const perms = usePerms(user);
  const found = findSubmodule(subKey);
  if (!found) return <Navigate to={PAYROLL_BASE} replace />;
  const { group, sub } = found;
  if (sub.href) return <Navigate to={sub.href} replace />;
  if (sub.key !== subKey) return <Navigate to={payrollSubUrl(sub.key)} replace />;
  const Cmp = sub.screen && Screens[sub.screen];
  const tabs = group.submodules;
  return (
    <>
      {tabs.length > 1 && (
        <div className="cc-tabs" role="tablist" style={{ '--n': Math.ceil(tabs.length / Math.ceil(tabs.length / 8)) }}>
          {tabs.map(t => (
            <Link key={t.key} role="tab" to={t.href || payrollSubUrl(t.key)} className={t.key === sub.key ? 'active' : ''}
                  aria-current={t.key === sub.key ? 'page' : undefined}>{t.title}</Link>
          ))}
        </div>
      )}
      <div className="cc-page-card">
        {Cmp ? <Cmp key={sub.key} perms={perms} sub={sub} />
          : (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <Icon name={sub.icon} size={40} />
              <h3 style={{ margin: '12px 0 6px' }}>{sub.title}</h3>
              <p className="muted">{sub.description}.</p>
              <p className="muted">Not available yet.</p>
            </div>)}
      </div>
    </>
  );
}

function OldLink() {
  const { subKey } = useParams();
  return <Navigate to={findSubmodule(subKey) ? payrollSubUrl(subKey) : PAYROLL_BASE} replace />;
}

export default function PayrollApp({ user, toast }) {
  return (
    <HRProvider user={user} toast={toast}>
      <div className="hr-scope">
        <Routes>
          <Route index element={<HubPage />} />
          <Route path="g/:groupKey" element={<GroupPage />} />
          <Route path="s/:subKey" element={<SubmodulePage user={user} />} />
          <Route path=":subKey" element={<OldLink />} />
          <Route path="*" element={<Navigate to={PAYROLL_BASE} replace />} />
        </Routes>
      </div>
    </HRProvider>
  );
}
